/*  ==========================================================================
    WEATHER DETAIL
    ========================================================================== */

/*
 * IMPORTS
 */

// node modules imports
import $ from 'jquery';
import 'jquery-inview';

// local imports
import * as vars from '../../globals/variables';
import * as utils from '../../utilities/utils';
import {weather_country} from "../../globals/variables";

/*
 * MODULE
 */

// hook function
function funcHook(container,data) {
}

// custom function
function funcCustom(container,data) {

    // magnific popup
    utils.mfp.initSingleImage(container);

}

// initialization
export function initWeatherDetail($element) {
    let container = $element.find('.eh-service');

    // config
    let config = {
        addParams: {},
        container: container,
        funcCustom: funcCustom,
        funcHook: funcHook,
        type: 'weather',
        subtype: 'detail',
        country:  vars.weather_country,
        location: vars.weather_location,
        provider: vars.weather_provider
    };

    // ehotelier service initialization (if element is in view)
    $element.one('inview', function() {
        utils.ehotelierLoader.initWeatherService(config);
    });

}


// WEBPACK FOOTER //
// ./source/js/modules/lib/weather-detail.js